<section class="page">
  <p-skeleton width="14rem" height="1.4rem" class="mb-2" />
  <p-skeleton width="24rem" height="1rem" />

  <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="6rem" height="0.9rem" />
      <p-skeleton width="8rem" height="1.6rem" class="mt-2" />
      <p-skeleton width="5rem" height="0.8rem" class="mt-2" />
    </div>
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="7rem" height="0.9rem" />
      <p-skeleton width="8rem" height="1.6rem" class="mt-2" />
      <p-skeleton width="6rem" height="0.8rem" class="mt-2" />
    </div>
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="9rem" height="0.9rem" />
      <p-skeleton width="8rem" height="1.6rem" class="mt-2" />
      <p-skeleton width="6rem" height="0.8rem" class="mt-2" />
    </div>
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="7rem" height="0.9rem" />
      <p-skeleton width="8rem" height="1.6rem" class="mt-2" />
      <p-skeleton width="6rem" height="0.8rem" class="mt-2" />
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
    <div class="md:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="12rem" height="1rem" />
      <p-skeleton width="8rem" height="0.9rem" class="mt-2" />
      <div class="skeletor-chart mt-4">
        <div class="skeletor-chart-bars">
          <div class="skeletor-bar" *ngFor="let h of barHeights">
            <p-skeleton width="100%" [height]="h + 'px'" />
          </div>
        </div>
        <div class="skeletor-chart-axis mt-2">
          <div class="skeletor-axis-tick" *ngFor="let h of barHeights">
            <p-skeleton width="2rem" height="0.75rem" />
          </div>
        </div>
      </div>
    </div>
    <div class="md:col-span-1 bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="10rem" height="1rem" />
      <div class="mt-3 space-y-2">
        <div *ngFor="let i of rows" class="flex justify-between items-center">
          <p-skeleton width="70%" height="1rem" />
          <p-skeleton width="5rem" height="0.9rem" />
        </div>
      </div>
      <p-skeleton width="9rem" height="1rem" class="mt-6" />
      <div class="mt-3 flex flex-wrap gap-2">
        <p-skeleton width="6rem" height="1.4rem" />
        <p-skeleton width="6rem" height="1.4rem" />
        <p-skeleton width="6rem" height="1.4rem" />
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="12rem" height="1rem" />
      <div class="mt-3">
        <div class="flex text-gray-600 py-2">
          <p-skeleton width="8rem" height="0.9rem" class="mr-2" />
          <p-skeleton width="6rem" height="0.9rem" class="mr-2" />
          <p-skeleton width="8rem" height="0.9rem" class="mr-2" />
          <p-skeleton width="6rem" height="0.9rem" />
        </div>
        <div class="mt-2">
          <div *ngFor="let i of rows" class="flex items-center py-2 border-t border-gray-200">
            <p-skeleton width="16rem" height="1rem" class="mr-2" />
            <p-skeleton width="8rem" height="1rem" class="mr-2" />
            <p-skeleton width="10rem" height="1rem" class="mr-2" />
            <p-skeleton width="6rem" height="1rem" />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <p-skeleton width="10rem" height="1rem" />
      <div class="mt-4 grid grid-cols-1 gap-4">
        <div *ngFor="let i of rows" class="space-y-1">
          <div class="flex items-center justify-between">
            <p-skeleton width="65%" height="1rem" />
            <p-skeleton width="4rem" height="0.9rem" />
          </div>
          <div class="w-full h-3 bg-gray-200 rounded">
            <p-skeleton width="100%" height="0.75rem" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
